export const tabFormatter = (tab) => {
  switch (tab) {
    case 'pharmacy':
      return '/pharmacy';
    case 'hra':
      return '/hra?noBackButton=true';
    case 'labs':
      return '/lab-test';
    case 'online-consults':
    case 'online-consultation':
      return '/consultation/online/preview';
    case 'offline-consults':
    case 'clinic-consultation':
      return '/consultation/preview';
    case 'dependents':
      return '/manage-dependents';
    case 'podcast':
      return '/health-content/podcasts-home';
    case 'financial-advisor':
      return '/consultation/doctor-select/issue?verticalId=45';
    case 'legal-advisor':
      return '/consultation/doctor-select/issue?verticalId=46';
    case 'counselors':
      return '/consultation/doctor-select/issue?verticalId=1';
    case 'yoga':
      return '/health-content/fitness-home';
    case 'meditation':
      return '/health-content/podcasts-home';
    case 'aia':
      return '/au-benefits';
    case 'rewards':
      return '/home/rewards';
    case 'universal-ahc':
      return '/lab-test/universal-ahc';
    case 'review-cart':
      return '/lab-test/review-cart';
    case 'order-summary':
      return '/lab-test/order-summary';
    case 'dental':
      return '/dental/preview';
    case 'vaccination':
      return '/vaccination/preview';
    case 'vision':
      return '/vision/preview';
    case 'opd-reimbursement':
      return '/reimbursement/preview';
    case 'claims':
      return '/claims';
    case 'reimbursement':
      return '/reimbursement/preview';
    default:
      return '/home';
  }
};

export const pbDetailFormatter = (tab, sourceId) => {
  switch (tab) {
    case 'reimbursement':
    case 'opd-reimbursement':
      return {
        pathname: '/claims/summary',
        state: { claimId: sourceId, goBack: false },
      };
    case 'vision':
      return {
        pathname: '/vision/status',
        state: { requestId: sourceId },
      };
    case 'vaccination':
      return {
        pathname: '/vaccination/status',
        state: { requestId: sourceId },
      };
    case 'dental':
      return {
        pathname: '/dental/appointment/appointment-status',
        state: { requestId: sourceId },
      };
    default:
      return null;
  }
};
